/* app/js/src/components/common/evrideo-dialog/evrideo-dialog.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host * {
  box-sizing: border-box;
  outline: none;
}
dialog {
  border-radius: 4px;
  min-width: 300px;
  padding: 0;
  border: transparent;
  box-shadow:
    0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
dialog.backdrop::backdrop {
  background-color: rgba(0, 0, 0, var(--backdrop-opacity));
}
dialog .header {
  padding: 10px 0 5px 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  row-gap: 0px;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}
dialog .header.success {
  background: #bff9dd;
}
dialog .header.success .title .text {
  color: #008545;
}
dialog .header.success .icon svg path {
  fill: #008545;
}
dialog .header.info {
  background: #bee9ff;
}
dialog .header.info .title .text {
  color: #0e71a3;
}
dialog .header.info .icon svg path {
  fill: #0e71a3;
}
dialog .header.warning {
  background: #ffddab;
}
dialog .header.warning .title .text {
  color: #a37300;
}
dialog .header.warning .icon svg path {
  fill: #a37300;
}
dialog .header.error {
  background: #ffc5c7;
}
dialog .header.error .title .text {
  color: #a33134;
}
dialog .header.error .icon svg path {
  fill: #a33134;
}
dialog .header.simple {
  background: transparent;
  border-bottom: 1.5px solid rgba(0, 0, 0, 0.85);
}
dialog .header.simple .title .text {
  color: rgba(0, 0, 0, 0.85);
}
dialog .header.simple .icon svg path {
  fill: rgba(0, 0, 0, 0.85);
}
dialog .header .title {
  display: flex;
  flex-direction: row;
  gap: 10px;
  row-gap: 0px;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  position: relative;
}
dialog .header .text {
  text-align: left;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  position: relative;
  text-transform: uppercase;
  flex: 1;
}
dialog .header .close {
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
dialog .header .close svg {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  position: relative;
  overflow: visible;
}
dialog .content {
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
dialog .content .content-text {
  text-align: left;
  padding: 10px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}
dialog .actions {
  -webkit-user-select: none;
  user-select: none;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.1);
  border-width: 1px 0px 0px 0px;
  padding: 14px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  row-gap: 0px;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
dialog .actions > div {
  cursor: pointer;
}
dialog .actions .cancel-button {
  border-radius: 4px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.14);
  border-width: 1px;
  padding: 9px 16px 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  row-gap: 0px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
dialog .actions .cancel-button div {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
dialog .actions .confirm-button {
  background: #2dbbfc;
  border-radius: 4px;
  padding: 9px 16px 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  row-gap: 0px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
dialog .actions .confirm-button div {
  color: #ffffff;
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
/*# sourceMappingURL=evrideo-dialog.component.css.map */
